import SidePanelOwnerItem from './SidePanelOwnerItem';

export default SidePanelOwnerItem;
